import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
    apiKey: "AIzaSyBMffK_J9JfM1b1xpisTPMZH39wEF_2wYM",
    authDomain: "citric-abbey-441708-t6.firebaseapp.com",
    projectId: "citric-abbey-441708-t6",
    storageBucket: "citric-abbey-441708-t6.firebasestorage.app",
    messagingSenderId: "870461189404",
    appId: "1:870461189404:web:4c5855c4e8166f136fded9"
  };

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging, getToken, onMessage };


